import { Outlet } from 'react-router-dom';
import { CookieConsent } from './CookieConsent';
import { EnhancedFooter } from './EnhancedFooter';
import { HeaderNav } from './HeaderNav';

export function Layout() {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <HeaderNav />
      <main className="flex-1 w-full max-w-[1024px] mx-auto px-2 sm:px-4 pb-8">
        <Outlet />
      </main>
      <EnhancedFooter />
      <CookieConsent />
    </div>
  );
}